import { render, staticRenderFns } from "./CollectStateTag.vue?vue&type=template&id=06c676e9&"
import script from "./CollectStateTag.vue?vue&type=script&lang=js&"
export * from "./CollectStateTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports